export var CustomEventTypes;
(function (CustomEventTypes) {
    CustomEventTypes["CHANGE"] = "change";
})(CustomEventTypes || (CustomEventTypes = {}));
export var PrefixedCustomEventTypes;
(function (PrefixedCustomEventTypes) {
    PrefixedCustomEventTypes["CHANGE"] = "darkmode:change";
})(PrefixedCustomEventTypes || (PrefixedCustomEventTypes = {}));
;
export var LegacyEventTypes;
(function (LegacyEventTypes) {
    LegacyEventTypes["CHANGE"] = "change";
})(LegacyEventTypes || (LegacyEventTypes = {}));
